document.addEventListener("DOMContentLoaded", function () {
    var modals = document.querySelectorAll('.modal');
    const body = document.querySelector('body');

    modals.forEach(function (modal) {
        let toggleModal = function () {
            modal.classList.toggle('opacity-0');
            modal.classList.toggle('pointer-events-none');
        };

        document.querySelectorAll('.modal-open[data-target="#' + modal.getAttribute('id') + '"]').forEach(function (link) {
            link.addEventListener('click', function (event) {
                event.preventDefault();
                toggleModal();
            });
        });

        const overlay = modal.querySelector('.modal-overlay');
        overlay.addEventListener('click', toggleModal);

        var closeModal = modal.querySelectorAll('.modal-close');
        for (var q = 0; q < closeModal.length; q++) {
            closeModal[q].addEventListener('click', toggleModal)
        }
    });

    document.onkeydown = function (evt) {
        evt = evt || window.event;
        var isEscape = false;
        if ("key" in evt) {
            isEscape = (evt.key === "Escape" || evt.key === "Esc")
        } else {
            isEscape = (evt.keyCode === 27)
        }

        if (isEscape) {
            modals.forEach(function (modal) {
                modal.classList.add('opacity-0');
                modal.classList.add('pointer-events-none');
            });
        }
    };
});
